/* eslint-disable consistent-return */
import { IStore } from 'store/types';
import { IApiList, IPaymentSet, ITipAcceptancePaymentSetPayouts } from 'types';

export const selectPaymentSetsForSite =
  () =>
  (state: IStore): IPaymentSet[] =>
    state.collections.payments?.data as IPaymentSet[];

export const selectTotalCountPaymentSetsForSite =
  () =>
  (state: IStore): number =>
    state.collections.payments?.total;

export const selectSiteTipAcceptancePaymentSets =
  () =>
  (state: IStore): IApiList<ITipAcceptancePaymentSetPayouts> =>
    state.collections.payments as IApiList<ITipAcceptancePaymentSetPayouts>;
